// extracted by mini-css-extract-plugin
module.exports = {"commentSection":"commentSection--ZvLau"};